import React from 'react'
import { noop } from 'lodash'
import withPhoto from '../../containers/withPhoto'
import Photo from '@components/Photo'
import { getPhotoIdFromKey } from '@utils/photo'
import { createLogger } from '@utils/logger'

const log = createLogger('PhotoRenderer', { prependScope: true })
log.setLevel('info')

const WrappedPhoto = withPhoto(Photo)

interface PhotoRendererProps {
  value?: string | null // should be the photo id or null
  parseValue?: (value: string | null) => string | null
  thumbnailStyle?: string
  onClick?: () => void
}

const PhotoRenderer: React.FC<PhotoRendererProps> & { RENDERER_TYPE: string } = props => {
  const { value, parseValue = getPhotoIdFromKey, thumbnailStyle = 'small_square', onClick = noop } = props

  log.debug('Rendering:', value)
  let content = null
  if (value) {
    const photoId = parseValue(value)
    content = <WrappedPhoto key="photo" value={photoId} thumbnailStyle={thumbnailStyle} />
  }

  return (
    <span className="content-renderer content-renderer--photo photo-renderer" onClick={onClick}>
      {content}
    </span>
  )
}

PhotoRenderer.RENDERER_TYPE = 'photo'

export default PhotoRenderer
